var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLockRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFE8E7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_8064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 16.6666H24.1666V14.9999C24.1666 12.6999 22.2999 10.8333 19.9999 10.8333C17.6999 10.8333 15.8333 12.6999 15.8333 14.9999V16.6666H14.9999C14.0833 16.6666 13.3333 17.4166 13.3333 18.3333V26.6666C13.3333 27.5833 14.0833 28.3333 14.9999 28.3333H24.9999C25.9166 28.3333 26.6666 27.5833 26.6666 26.6666V18.3333C26.6666 17.4166 25.9166 16.6666 24.9999 16.6666ZM19.9999 24.1666C19.0832 24.1666 18.3333 23.4166 18.3333 22.4999C18.3333 21.5833 19.0832 20.8333 19.9999 20.8333C20.9166 20.8333 21.6666 21.5833 21.6666 22.4999C21.6666 23.4166 20.9166 24.1666 19.9999 24.1666ZM22.5832 16.6666H17.4166V14.9999C17.4166 13.5749 18.5749 12.4166 19.9999 12.4166C21.4249 12.4166 22.5832 13.5749 22.5832 14.9999V16.6666Z",
    fill: "#EB0000",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_8064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLockRed);
export default __webpack_public_path__ + "static/media/icon_lock_red.3cd3c5cdeb2376f150f9bc4dd1293882.svg";
export { ForwardRef as ReactComponent };